import { render, staticRenderFns } from "./photoInfo.vue?vue&type=template&id=c90babb4"
import script from "./photoInfo.vue?vue&type=script&lang=js"
export * from "./photoInfo.vue?vue&type=script&lang=js"
import style0 from "./photoInfo.vue?vue&type=style&index=0&id=c90babb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports